import Onboarding from "@/views/agent-onboarding/Onboarding";

export default [
  {
    path: "/agent-onboarding",
    component: Onboarding,
    meta: {
      roles: [],
    },
    children: [
      {
        path: ":inviteCode?",
        name: "agent-onboarding",
        component: () =>
          import("@/components/agent-onboarding/AgentOnboarding"),
        meta: {
          roles: [],
        },
        props: true,
      },
      {
        path: ":inviteCode?/decline",
        name: "decline-invitation",
        component: () =>
          import("@/components/agent-onboarding/AgentOnboarding"),
        meta: {
          roles: [],
        },
        props: true,
      },
    ],
  },
];
